import AssignedInterviewReviewsManager from './AssignedInterviewReviewsManager.container';

export default AssignedInterviewReviewsManager;
